export const imagesCode = {
  banner1: {
    code: "${merchantId}_tmpl_img_28",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fnext_pos.jpg?alt=media&token=d3520ab9-b03a-4807-809d-efdaa908329c",
  },
  banner2: {
    code: "${merchantId}_tmpl_img_27",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fnext_printer.png?alt=media&token=a1a0a531-f7d3-4bdf-8959-b66919e0bc8a",
  },
  banner3: {
    code: "${merchantId}_tmpl_img_25",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fnext_laptop.png?alt=media&token=150a5c1e-3494-4ca0-9272-1c66556eb0ec",
  },
  banner4: {
    code: "${merchantId}_tmpl_img_26",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fimage%2024.png?alt=media&token=9dbe0c4f-15b1-42f9-a5ae-7c1b916e4d25",
  },
  banner5: {
    code: "${merchantId}_tmpl_img_29",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FScreenshot%20(6).png?alt=media&token=e8d24d11-3c9b-44d9-aa43-0db1b3425efe",
  },
};

export const titleCodes = {
  title: {
    code: "${merchantId}_tmpl_title_3",
    title: "NEXT POS",
  },
  title1: {
    code: "${merchantId}_tmpl_title_4",
    title: "Printers",
  },
  title2: {
    code: "${merchantId}_tmpl_title_5",
    title: "Laptop",
  },
  title3: {
    code: "${merchantId}_tmpl_title_6",
    title: "iPhone and accessories",
  },
};

export const descCodes = {
  desc: {
    code: "${merchantId}_tmpl_text_1",
    desc: "Slim and Compact Windows Touch Screen POS for Shopping mall, Supermarket, Minimart, Spa, Saloon, Coffee Shop, Teahouse, Bar & Restaurant. ",
  },
  desc1: {
    code: "${merchantId}_tmpl_text_2",
    desc: "ID card printers for Student ID, Staff ID card, Member Cards, etc. Direct-to-card printer  and can be upgraded from single-side to dual-side printing and can be equipped with magnetic stripe encoding, smart chip encoding and contactless encoding systems",
  },
};
